'use strict'

import { GLOBAL } from "../constants/ActionTypes"

const initialGlobalState = {
    HEIGHT: null,
    WIDTH: null,
    SCROLL_TOP: null,
    FIXED_TOP_SHOW: 700,
    SCROLL_BOTTOM: 0,
    PAGESHOW:false,
    CENTERMODEL: {},
    BEAUTYHREF: {},
    TOPRIGHTMODEL: {}
}

export default function ( state = initialGlobalState, action = {} ){
    let HEIGHT = action.HEIGHT;
    let WIDTH = action.WIDTH;
    let SCROLL_TOP = action.SCROLL_TOP;
    let SCROLL_BOTTOM = action.SCROLL_BOTTOM;
    let PAGESHOW = action.PAGESHOW;
    let CENTERMODEL = action.CENTERMODEL;
    let BEAUTYHREF = action.BEAUTYHREF;
    let TOPRIGHTMODEL = action.TOPRIGHTMODEL;
    switch( action.type ){
        case GLOBAL.SCROLL_BOTTOM:
            return Object.assign({},state,{
                SCROLL_BOTTOM
            })
            break;
        case GLOBAL.HEIGHT:
            return Object.assign({},state,{
                HEIGHT
            })
            break;
        case GLOBAL.WIDTH:
            return Object.assign({},state,{
                WIDTH
            })
            break;
        case GLOBAL.SCROLL_TOP:
            return Object.assign({},state,{
                SCROLL_TOP
            })
            break;
        case GLOBAL.PAGESHOW:
            return Object.assign({},state,{
                PAGESHOW
            })
            break;
        case GLOBAL.CENTERMODEL:
            return Object.assign({},state,{
                CENTERMODEL
            })
            break; 
        case GLOBAL.BEAUTYHREF:
            return Object.assign({},state,{
                BEAUTYHREF
            })
            break;
        case GLOBAL.TOPRIGHTMODEL:
            return Object.assign({},state,{
                TOPRIGHTMODEL
            })
            break;
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./common/reducers/global.js